"use client";

import React, {
    useState
} from "react";
import {
    Row,
    Col,
    Form
} from "react-bootstrap";
import {
    Link,
    useNavigate
} from "react-router-dom";
import {
    setToken
} from "../../../utils/auth";

const SignInForm = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const handleLogin = async (e) => {
        e.preventDefault();
        console.log(process.env.REACT_APP_API_BASE_URL);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/get-user`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    email,
                    password
                }),
            });

            // Check if response is JSON
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                const text = await response.text();
                console.error('Server returned non-JSON response:', text);
                alert('Server error: ' + text);
                return;
            }

            const user = await response.json();
            
            if (response.ok) {
                if (user.token) {
                    console.log(user.token);
                    setToken(user.token);
                }
                navigate("/tuvien/tindang");
                console.log('Login successful:', user);
            } else {
                console.error('Login failed:', user);
                alert(user.message || 'Login failed');
            }
        } catch (error) {
            console.error('Login error:', error);
            alert('Unable to connect to server: ' + error.message);
        }
    };


    return (
        <>
            <div
                className="auth-main-content m-auto m-1230 px-3">
                <Row
                    className="align-items-center">
                    <Col
                        lg={6}
                        className="d-none d-lg-block">
                        <img
                            src="/images/tuviendenthanh/thanh-martin-tieu-su-2.jpg"
                            className="rounded-3"
                            alt="login"
                            width={646}
                            height={804}
                        />
                    </Col>

                    <Col
                        lg={6}>
                        <div
                            className="mw-480 ms-lg-auto">
                            <div
                                className="d-inline-block mb-4">
                                <img
                                    src="/images/tuviendenthanh/favicon.jpg"
                                    className="rounded-3 for-light-logo"
                                    alt="login"
                                    width={100}
                                    height={26}
                                />
                                <img
                                    src="/images/tuviendenthanh/favicon.jpg"
                                    className="rounded-3 for-dark-logo"
                                    alt="login"
                                    width={100}
                                    height={26}
                                />
                            </div>

                            <h3 className="fs-28 mb-2">Chào
                                mừng
                                bạn
                                đến
                                với
                                trang
                                quản
                                trị</h3>
                            <p className="fw-medium fs-16 mb-4">
                                Nguyện
                                xin
                                Thiên
                                Chúa
                                tuôn
                                đổ
                                Hồng
                                Ân
                                trên
                                Anh
                                Em
                            </p>

                            <div
                                className="row justify-content-center">
                      

                            </div>

                            <Form
                                onSubmit={handleLogin}>
                                <Form.Group
                                    className="mb-4">
                                    <label
                                        className="label text-secondary">Địa chỉ email</label>
                                    <Form.Control
                                        type="email"
                                        className="h-55"
                                        placeholder="example@trezo.com"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                    />
                                </Form.Group>

                                <Form.Group
                                    className="mb-4">
                                    <label
                                        className="label text-secondary">Mật khẩu</label>
                                    <Form.Control
                                        type="password"
                                        className="h-55"
                                        placeholder="Type password"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                </Form.Group>

                                <Form.Group
                                    className="mb-4">
                                    <Link
                                        to="/authentication/forgot-password"
                                        className="fw-medium text-primary text-decoration-none"
                                    >
                                        Quên mật khẩu?
                                    </Link>
                                </Form.Group>

                                <Form.Group
                                    className="mb-4">
                                    <button
                                        type="submit"
                                        className="btn btn-primary fw-medium py-2 px-3 w-100"
                                    >
                                        <div
                                            className="d-flex align-items-center justify-content-center py-1">
                      <span
                          className="material-symbols-outlined fs-20 text-white me-2">
                        login
                      </span>
                                            <span>Đăng nhập</span>
                                        </div>
                                    </button>
                                </Form.Group>

                                {/*<Form.Group>*/}
                                {/*    <p>*/}
                                {/*        Don’t*/}
                                {/*        have*/}
                                {/*        an*/}
                                {/*        account.{" "}*/}
                                {/*        <Link*/}
                                {/*            to="/authentication/sign-up"*/}
                                {/*            className="fw-medium text-primary text-decoration-none"*/}
                                {/*        >*/}
                                {/*            Sign*/}
                                {/*            Up*/}
                                {/*        </Link>*/}
                                {/*    </p>*/}
                                {/*</Form.Group>*/}
                            </Form>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default SignInForm;
